import { carryAdditionExplanation, createNaturalArithmeticTask, randInt } from "./sharedNaturalArithmetic";

function pickData() {
  for (let i = 0; i < 500; i += 1) {
    const a = randInt(18, 69);
    const b = Math.random() < 0.35 ? randInt(3, 9) : randInt(14, 39);
    if ((a % 10) + (b % 10) >= 10 && a + b < 100) return { a, b, op: "+", result: a + b };
  }
  return { a: 27, b: 36, op: "+", result: 63 };
}

const mod = createNaturalArithmeticTask({
  type: "NaturalAddTwoDigitCarryTask",
  pickData,
  explain: carryAdditionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
